import { 
    distanseBetweenLayers, 
    getNotCenteredCoordinateForAnimationByAngle, 
    BallPositionByDot, 
    ballDiametr,
    parabolic,
    PARABOLIC_TIME
 } from '../../initials';
 export class ParabolicTopRightTopLeft {
    constructor({
        fromRowIndex,
        fromDotIndex,
        toRowIndex,
        toDotIndex,
        dots,
    }) {
        this.fromRowIndex = fromRowIndex;
        this.fromDotIndex = fromDotIndex;
        this.toRowIndex = toRowIndex;
        this.toDotIndex = toDotIndex;
        this.dots = dots;
    }

    static getAnimationSettings() {
        return {
            avaiableForMultipleLevels: false,
            type: 'ParabolicTopRightTopLeft',
            fromBallPositionByDot: BallPositionByDot.TOP_RIGHT,
            toBallPositionByDot: BallPositionByDot.TOP_LEFT,
        };
    }

    getAnimationTime() {
        return PARABOLIC_TIME * (this.toRowIndex - this.fromRowIndex);
    }

    animate(time) {
        const fullTime = this.getAnimationTime();
        const t = time / fullTime;

        const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
        const endDot = this.dots[this.toRowIndex][this.toDotIndex];

        const startXY = getNotCenteredCoordinateForAnimationByAngle(startDot.dotX, startDot.dotY, Math.PI / 4);
        const endXY = getNotCenteredCoordinateForAnimationByAngle(endDot.dotX, endDot.dotY, 3 * Math.PI / 4);

        return {
            x: parabolic(
                startXY.x, 
                startXY.x + ballDiametr / 2, 
                endXY.x, 
                t,
            ),
            y: parabolic(
                startXY.y, 
                startXY.y - distanseBetweenLayers, 
                endXY.y, 
                t,
            ),
        };
    }
}